import { Reducer } from "redux";
import { UrlBuilderTypes } from "store/url-builder/types";
import { UrlBuilderPublicState } from ".";

const initialState: UrlBuilderPublicState = {
  _id: "",
  userId: "",
  cardId: 0,
  info: {
    phoneNumber: "",
    email: "",
    calendar: "",
    location: "",
    website: "",
    links: [],
  },
  aboutMe: { text: "" },
  socialNetworks: [],
  video: {
    file: {
      _id: "0",
      fileName: "",
      filePath: "",
      mimeType: "",
      createdAt: "",
      updatedAt: "",
      __v: 0,
    },
    actionType: null,
    videoUrl: "",
  },
  images: [],
  testimonials: [],
  customCTA: { buttonLink: "", buttonText: "", buttonColor: "" },
  appStores: [],
  contactForm: {
    contactMail: "",
    fields: [
      {
        fieldName: "Full Name",
        fieldType: "Text",
        isRequired: true,
        editable: false,
      },
      {
        fieldName: "Email Adress",
        fieldType: "Email",
        isRequired: true,
        editable: false,
      },
      {
        fieldName: "Phone Number",
        fieldType: "Number",
        isRequired: true,
        editable: false,
      },
      {
        fieldName: "Message",
        fieldType: "Textarea",
        isRequired: true,
        editable: false,
      },
    ],
  },
  primaryColor: { color: "#000000" },
  published: false,
  paymentOptions: [],
  urlDesignType: "PRO",
  permissions: [],
  order: [],
};

const UrlBuilderPublicReducer: Reducer<UrlBuilderPublicState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case UrlBuilderTypes.SET_BUILDER_DATA: {
      if (action.data.contactForm.fields.length === 0)
        action.data.contactForm.fields = state.contactForm.fields;
      return { ...state, ...action.data };
    }
    case UrlBuilderTypes.SET_BUILDER_PERMISSIONS: {
      return { ...state, permissions: action.data };
    }
    case UrlBuilderTypes.UPDATE_BUILDER_PERMISSIONS: {
      const newPermissions = state.permissions.map((p) => {
        if (
          p.objectId === action.data.objectId &&
          p.objectPermission.objectPermissionId ===
            action.data.objectPermission.objectPermissionId
        )
          return action.data;

        return p;
      });
      return { ...state, permissions: newPermissions };
    }
    default:
      return state;
  }
};

export default UrlBuilderPublicReducer;
